import React from 'react'
import Image from "../../asserts/images/e.png" ;

function Informatique() {
  return (
    <div className='contentimagesDirection'>
    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Informaticien-Technicien :<br/> Mehdi Sghaier </p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> sghmhfr@gmail.com</p>
            </div>
    </div>

    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Informaticien-Technicien : <br/> Nejmeddine Rassas</p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> nejmeddine112@gmail.com</p>
            </div>
    </div>
        
       
    </div>
  )
}

export default Informatique